import styled from 'styled-components';

export const VariableList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${({ theme }) => theme.white};
  height: 100%;
  padding: 1rem;
  border-radius: 4px;
`;

export const SectionTitle = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.pantone657C};
  font-weight: bold;
`;

export const GroupLabel = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.pantone657C};
  font-weight: bold;
  margin-top: 0.25rem;
`;

export const GroupDivider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.grayLight ?? '#e0e0e0'};
  margin: 0;
`;

export const VariableChip = styled.div<{ $used: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.875rem;
  border-radius: 8px;
  border: 1px solid
    ${({ $used }) => ($used ? '#a5d6a7' : '#ef9a9a')};
  background: ${({ $used }) => ($used ? '#e8f5e9' : '#ffebee')};
  cursor: default;
`;

export const VariableName = styled.span`
  font-family: 'Courier New', monospace;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${({ theme }) => theme.pantoneBlack};
  word-break: break-all;
`;

export const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.125rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.grayDark};
  border-radius: 4px;
  flex-shrink: 0;
  margin-left: 0.5rem;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: ${({ theme }) => theme.pantone2190C};
    background: rgba(0, 0, 0, 0.06);
  }
`;
